import { render, staticRenderFns } from "../template/reg_4.html?vue&type=template&id=0dcec918&external"
import script from "./Reg-4.vue?vue&type=script&lang=js"
export * from "./Reg-4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports